import { render, staticRenderFns } from "./Degree.vue?vue&type=template&id=48f11e24&scoped=true&"
import script from "./Degree.vue?vue&type=script&lang=ts&"
export * from "./Degree.vue?vue&type=script&lang=ts&"
import style0 from "./Degree.vue?vue&type=style&index=0&id=48f11e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f11e24",
  null
  
)

export default component.exports